<template>
 <div id="log-in-form" class="d-flex justify-content-center align-items-center login-page">
    <div v-if="!isLoggingIn" class="p-5 text-center login-box">
      <img class="img-fluid" src="../assets/maadi_graphics-01.png" alt="" style="max-width: 300px">
      <hr/>
      <div class="d-flex justify-content-around">
        <a :href="slack_url" v-b-tooltip.hover title="Sign in with Slack"><i class="fab fa-slack"></i></a>
        <a :href="linkedin_url" v-b-tooltip.hover title="Sign in with LinkedIn"><i class="fab fa-linkedin"></i></a>
      </div>
      <hr/>
      <div class="d-flex justify-content-around">
        <b-form @submit="onSubmit" style="width: 100%" >
          <b-form-group>
            <b-form-input
              class="clear-input"
              id="username-input"
              type="text"
              v-model="formData.username"
              placeholder="enter username"
              autocomplete="username"
            />
          </b-form-group>
          <b-form-group>
            <b-form-input
              class="clear-input"
              id="password-input"
              type="password"
              v-model="formData.password"
              placeholder="enter password"
              autocomplete="password"
            />
          </b-form-group>
          <b-button id="submit" type="submit" variant="primary" style="border-radius: 0; background: none; border-color: #fff;">Submit</b-button>
        </b-form>
      </div>
      <hr/>
      <div v-if="loginErrorMessage" class="d-flex justify-content-around" style="color: #ffffff; font-weight: 300;">
        {{ this.loginErrorMessage }}
      </div>
      <span v-if="hasError" class="error-message text-center">{{ this.errorMessage}}<br></span>
      <span class="version-note">Version 0.4</span>
      <br>
    </div>
    <div v-if="isLoggingIn" class="p-5 text-center login-box">
      <div class="spinner-border text-light" role="status"></div>
    </div>
 </div>
</template>

<script>
import authentication from '../Authentication'
import {mapState} from 'vuex'

export default {
  name: 'login',
  data () {
    return {
      isLoggingIn: false,
      loginErrorMessage: null,
      slack_url: authentication.getSlackURL(),
      linkedin_url: authentication.getLinkedinURL(),
      formData: {username: '', password: ''}
    }
  },
  computed: {
    hasError: {
      get () { return this.$store.state.hasError },
      set (value) { this.$store.commit('clearError') }
    },
    ...mapState({
      errorMessage: state => state.errorMessage
    })
  },
  methods: {
    onSubmit (e) {
      e.preventDefault()
      this.loginErrorMessage = null
      if (this.formData.username === '') {
        this.loginErrorMessage = 'Please input a username.'
        return
      }
      if (this.formData.password === '') {
        this.loginErrorMessage = 'Please input a password.'
        return
      }
      this.isLoggingIn = true
      authentication.authenticateWithPassword(this.formData.username, this.formData.password)
        .then(response => {
          this.isLoggingIn = false
          if (!response.data.success) {
            this.loginErrorMessage = response.data.message
          }
        })
        .catch(() => {
          this.isLoggingIn = false
        })
    },
    authenticateWithMAACKS () {
      this.loginErrorMessage = null
      authentication.authenticateWithOAuth(this.$route.query.source, this.$route.query.code, this.$route.query.state)
        .then(response => {
          this.isLoggingIn = false
          if (!response.data.success) {
            this.loginErrorMessage = response.data.message
          }
          if (response.data.role === 'unknown') {
            this.loginErrorMessage = 'Thank you. Your account will be verified shortly.'
          }
        })
        .catch(() => {
          this.isLoggingIn = false
        })
    }
  },
  beforeMount () {
    if (this.$route.query.code === undefined || this.$route.query.state === undefined) {
      return
    }
    if (this.$route.query.code) {
      this.isLoggingIn = true
    }
    this.authenticateWithMAACKS()
  }
}
</script>

<style scoped>
.login-page{
  height: 100vh;
  background: url('../assets/background_maadi.png') no-repeat center center fixed;
  background-size: cover;
  overflow: hidden;
}
.login-box{
 background-color:rgba(0, 0, 0, 0.25);

 border: solid 1px #fff;
}
hr{
 border-color: #fff;
}
.fab {
 color: #fff;
 font-size: 3em;
}
.fab:hover{
 color: #ccc;
}
.error-message{
 color: #fff;
 font-weight: 300;
 font-size: 1em;
}
.version-note{
 color: #fff;
 font-weight: 300;
 font-size: .5em;
}
.clear-input{
 background: none;
 font-weight: 300;
 border-radius: 0;
 color: #fff
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue